module.exports = __webpack_public_path__ + "static/media/inventory.5dfaabf7.svg";